import React from 'react'
import { IonContent, IonFooter, IonHeader, IonModal } from '@ionic/react'
import { payPlanMobx } from '@mobx/mall/payment'
import { observer } from 'mobx-react'
import { Pay, PayButton } from '@pages/mall/checkout/component'
import './index.scss'

interface ICartProps {
  reject?: () => void;
}

const SettlementCard: React.FC<ICartProps> = ({ reject }) => {
  return (
    <IonModal
      isOpen
      cssClass='mall-settlement-card height620-modal'
      onDidDismiss={() => {
        payPlanMobx.setUserChangedPlan(false)
        reject && reject()
      }}
    >
      <IonContent>
        <div className='settlement-card-pay'>
          <Pay />
        </div>
      </IonContent>
      <IonFooter className='settlement-card-footer'>
        <PayButton />
      </IonFooter>
    </IonModal>
  )
}

export default observer(SettlementCard)
